module.exports = __webpack_public_path__ + "static/media/gameplay.fe285ca9.mp4";